module.exports = __webpack_public_path__ + "img/NaturalDisasterWarning.d722c329.svg";